import type { Action, ActionsArgs } from '../types'
import { getDestructiveActions } from './destructiveActions'
import { getMutableActions } from './mutableActions'
import { getShareActions } from './shareActions'
import { getViewActions } from './viewActions'

export const buildActions = ({
  assetDownloadEnabled,
  bulkDownloadEnabled,
  canToggleSections,
  contentDownloadEnabled,
  contentGenerationEnabled,
  contentTransformationEnabled,
  contentHasPlacements,
  contentTextCopyEnabled,
  deletable,
  duplicationEnabled,
  exportEnabled,
  isPresenting,
  placementsEnabled,
  postType,
  previewUrlEnabled,
  queueView,
  renderingEnabled,
  retweetEnabled,
  serviceName,
  showAIActions,
  userCanEditContent,
}: ActionsArgs): Action[] => [
  ...getMutableActions({
    contentGenerationEnabled,
    contentTransformationEnabled,
    duplicationEnabled,
    isPresenting,
    queueView,
    retweetEnabled,
    serviceName,
    showAIActions,
    userCanEditContent,
  }),
  { type: 'separator' },
  ...getViewActions({
    canToggleSections,
    contentHasPlacements,
    isPresenting,
    placementsEnabled,
    postType,
    previewUrlEnabled,
    userCanEditContent,
  }),
  { type: 'separator' },
  ...getShareActions({
    assetDownloadEnabled,
    bulkDownloadEnabled,
    contentDownloadEnabled,
    contentTextCopyEnabled,
    exportEnabled,
    postType,
    previewUrlEnabled,
    renderingEnabled,
  }),
  { type: 'separator' },
  ...getDestructiveActions({
    isPresenting,
    deletable,
    queueView,
    userCanEditContent,
  }),
]
